import AllSetPage from '~/client-flow/clientOb/AllSetStep/AllSetPage';
import NoPermissionsRelationshipApproved from '~/client-flow/clientOb/AllSetStep/noPermissionsRelationshipApproved';
import ClientOnboarding from '~/client-flow/clientOb/ClientOnboarding';
import RelationshipApprovedWithAnimations from '~/client-flow/clientOb/RelationshipSignedStep/RelationshipApprovedWithAnimations';
import AgreementStudioPage from '~/components/AgreementStudioPage/AgreementStudioPage';
import AgreementStudioTemplates from '~/components/AgreementStudioPage/AgreementStudioTemplateMode/AgreementStudioTemplates';
import CanceledProposalPage from '~/components/CanceledProposalPage/CanceledProposalPage';
import ExpiredProposalPage from '~/components/ExpiredProposalPage/ExpiredProposalPage';
import { routes } from '~/constants';
import { AvailableAppsPage } from '~/integrations/AvailableAppsPage/AvailableAppsPage';
import ActivityLogsPage from '~/pages/ActivityLogsPage/ActivityLogsPage';
import AdditionalPaymentProcessorInfoPage from '~/pages/AdditionalPaymentProcessorInfoPage/AdditionalPaymentProcessorInfoPage';
import AgreementMinisite from '~/pages/AgreementMinisite/AgreementMinisite';
import { AgreementsDashboard } from '~/pages/AgreementsDashboard/AgreementsDashboard';
import AnchorBilling from '~/pages/AnchorBilling/AnchorBilling';
import APIKeysPage from '~/pages/APIKeysPage/APIKeysPage';
import { ArchivedProposalsDashboard } from '~/pages/ArchivedProposalsDashboard/ArchivedProposalsDashboard';
import { BusinessDetails } from '~/pages/BusinessDetails';
import ConnectedAppsPage from '~/pages/ConnectedAppsPage/ConnectedAppsPage';
import { ContactsDashboard } from '~/pages/ContactsDashboard';
import { DraftsDashboard } from '~/pages/DraftsDashboard';
import GlobalBillingHub from '~/pages/GlobalBillingHub/GlobalBillingHub';
import HomePage from '~/pages/HomePage/HomePage';
import ImportAgreements from '~/pages/ImportAgreements/ImportAgreements';
import ImportContacts from '~/pages/ImportContacts/ImportContacts';
import ImportServices from '~/pages/ImportServices/ImportServices';
import InvoicesDashboard from '~/pages/InvoicesDashboard/InvoicesDashboard';
import NoAccessPage from '~/pages/NoAccessPage/NoAccessPage';
import Notification from '~/pages/Notification/Notification';
import { NotificationActionPage } from '~/pages/NotificationAction';
import NotificationSettings from '~/pages/NotificationSettings/NotificationSettings';
import PayoutsDashboard from '~/pages/PayoutsDashboard/PayoutsDashboard';
import ProfilePage from '~/pages/Profile/Profile';
import ProposalDefaults from '~/pages/ProposalDefaults/ProposalDefaults';
import { ProposalsDashboard } from '~/pages/ProposalsDashboard';
import ProposalTemplateLoader from '~/pages/ProposalTemplates/ProposalTemplateLoader';
import { ProposalTemplates } from '~/pages/ProposalTemplates/ProposalTemplates';
import { RedirectPage } from '~/pages/RedirectPage';
import { ReferralDashboard } from '~/pages/ReferralDashboard/ReferralDashboard';
import { Reports } from '~/pages/Reports/Reports';
import { BundlesPage } from '~/pages/ServicesLibrary/BundlesPage/BundlesPage';
import { ServicesPage } from '~/pages/ServicesLibrary/ServicesPage/ServicesPage';
import TeamPage from '~/pages/TeamPage/TeamPage';
import { ResetPasswordScreen, SetPasswordScreen, SignupScreen } from '~/pages/unAuthorizedPages';
import { VendorDashboard } from '~/pages/VendorDashboard/VendorDashboard';
export const unauthorizedPages = [
    {
        url: routes.signUp,
        component: SignupScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.setPassword,
        component: SetPasswordScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.resetPassword,
        component: ResetPasswordScreen,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.notification(),
        component: Notification,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.noPermissionsRelationshipAlreadyApproved,
        component: NoPermissionsRelationshipApproved,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.allSignaturesAcquired(),
        component: RelationshipApprovedWithAnimations,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.expiredProposalPage,
        component: ExpiredProposalPage,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.canceledProposalPage,
        component: CanceledProposalPage,
        supportsMobileViewport: true,
        enableIntercom: false
    },
    {
        url: routes.additionalPaymentProcessorInfo,
        component: AdditionalPaymentProcessorInfoPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.notificationAction,
        component: NotificationActionPage,
        supportsMobileViewport: true,
        enableIntercom: true
    },
    {
        url: routes.noAccessPage,
        component: NoAccessPage,
        supportsMobileViewport: true,
        enableIntercom: true
    }
];
export const getAuthorizedPages = ()=>[
        {
            url: routes.redirect,
            component: RedirectPage,
            supportsMobileViewport: true,
            allowPartiallyOnboardedVendor: true,
            enableIntercom: true
        },
        {
            url: routes.home,
            component: HomePage,
            allowPartiallyOnboardedVendor: true,
            enableIntercom: true,
            supportsMobileViewport: false,
            supportsMobileDevice: false
        },
        {
            url: routes.agreementStudio,
            component: AgreementStudioPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.proposalTemplateStudio,
            component: AgreementStudioTemplates,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.minisite(),
            component: AgreementMinisite,
            enableIntercom: true
        },
        {
            url: routes.draft(),
            component: AgreementStudioPage,
            vendorOnly: true,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.proposalTemplate(),
            component: ProposalTemplateLoader,
            enableIntercom: true,
            supportsMobileViewport: true,
            supportsMobileDevice: true
        },
        {
            url: routes.clientOnboarding(),
            component: ClientOnboarding,
            supportsMobileViewport: true,
            enableIntercom: false
        },
        {
            url: routes.allSet(),
            component: AllSetPage,
            supportsMobileViewport: true,
            enableIntercom: false
        }
    ];
export function getHomePagePages() {
    const routeConfigs = [
        {
            url: routes.vendorDashboard,
            component: VendorDashboard,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.agreementsDashboard,
            component: AgreementsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.proposalsDashboard,
            component: ProposalsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.draftsDashboard,
            component: DraftsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.archivedProposals,
            component: ArchivedProposalsDashboard,
            enableIntercom: true
        },
        {
            url: routes.proposalTemplates,
            component: ProposalTemplates,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.proposalDefaults,
            component: ProposalDefaults,
            enableIntercom: true
        },
        {
            url: routes.invoicesDashboard,
            component: InvoicesDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.payoutsDashboard,
            component: PayoutsDashboard,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.contacts,
            component: ContactsDashboard,
            supportsMobileDevice: true,
            supportsMobileViewport: true,
            enableIntercom: true
        },
        {
            url: routes.serviceLibrary,
            component: ServicesPage,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.bundlesLibrary,
            component: BundlesPage,
            enableIntercom: true,
            supportsMobileDevice: true,
            supportsMobileViewport: true
        },
        {
            url: routes.availableApps,
            component: AvailableAppsPage,
            enableIntercom: true
        },
        {
            url: routes.notifications,
            component: NotificationSettings,
            enableIntercom: true
        },
        {
            url: routes.profile,
            component: ProfilePage,
            enableIntercom: true
        },
        {
            url: routes.businessDetails,
            component: BusinessDetails,
            enableIntercom: true
        },
        {
            url: routes.team,
            component: TeamPage,
            enableIntercom: true
        },
        {
            url: routes.anchorBilling,
            component: AnchorBilling,
            enableIntercom: true
        },
        {
            url: routes.importAgreements,
            component: ImportAgreements,
            enableIntercom: true
        },
        {
            url: routes.importServices,
            component: ImportServices,
            enableIntercom: true
        },
        {
            url: routes.importContacts,
            component: ImportContacts,
            enableIntercom: true
        },
        {
            url: routes.minisite(undefined),
            component: AgreementMinisite,
            enableIntercom: true
        },
        {
            url: routes.globalBillingHub,
            component: GlobalBillingHub,
            enableIntercom: true
        },
        {
            url: routes.referrals,
            component: ReferralDashboard,
            enableIntercom: true
        },
        {
            url: routes.reports,
            component: Reports,
            enableIntercom: true
        },
        {
            url: routes.anchorApiKeys,
            component: APIKeysPage,
            enableIntercom: true
        },
        {
            url: routes.connectedApps,
            component: ConnectedAppsPage,
            enableIntercom: true
        },
        {
            url: routes.activityLogs,
            component: ActivityLogsPage,
            enableIntercom: true
        }
    ];
    return routeConfigs;
}
